import React from 'react';
import './SetCompleteConfirm.css';

const SetCompleteConfirm = ({ isOpen, onClose, onConfirm, meetingName }) => {
  if (!isOpen) return null;

  return (
    <div className="set-complete-overlay">
      <div className="set-complete-modal">
        <div className="set-complete-header">
          <h2>Set Meeting Complete</h2>
          <button className="close-button" onClick={onClose}>
            <i className="ti ti-x"></i>
          </button>
        </div>
        
        <div className="set-complete-content">
          <div className="info-icon">
            <i className="ti ti-check-circle"></i>
          </div>
          
          <h3>Are you sure you want to mark this meeting as complete?</h3>
          
          <p className="meeting-name">
            <strong>{meetingName || 'Untitled Meeting'}</strong>
          </p>
          
          <div className="info-message">
            <p>This action will:</p>
            <ul>
              <li>Mark the meeting as completed</li>
              <li>Move it to the completed meetings section</li>
              <li>Allow others to view the meeting results</li>
              <li>Preserve all meeting data and transcripts</li>
            </ul>
            <p><strong>This action can be reversed by resetting the meeting data.</strong></p>
          </div>
        </div>
        
        <div className="set-complete-actions">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="complete-button" onClick={onConfirm}>
            Set Meeting Complete
          </button>
        </div>
      </div>
    </div>
  );
};

export default SetCompleteConfirm;

